import * as React from "react";

import { cn } from "@/lib/utils";

type PageHeaderProps = {
  /** Page title. Strings are rendered as <h1>; pass a node for custom markup. */
  title: React.ReactNode;
  /** Optional row under the title (tags, item count, status badges). */
  meta?: React.ReactNode;
  /** Optional element on the right of the title row (date picker, primary action). */
  actions?: React.ReactNode;
  /**
   * Optional tab bar (a line-variant `<TabsList>`); the active tab's underline
   * overlaps the header's hairline below it.
   */
  tabs?: React.ReactNode;
  className?: string;
};

export function PageHeader({
  title,
  meta,
  actions,
  tabs,
  className,
}: PageHeaderProps) {
  return (
    <div className={cn("border-border border-b", className)}>
      <div className="flex items-start justify-between gap-4 pb-4">
        <div className="min-w-0 flex-1">
          {typeof title === "string" ? (
            <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          ) : (
            title
          )}
          {meta && <div className="mt-1">{meta}</div>}
        </div>
        {actions && <div className="shrink-0">{actions}</div>}
      </div>
      {tabs}
    </div>
  );
}
